document.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('click', async (event) => {
    const removeButton = event.target.closest('cart-remove-button a');
    if (!removeButton) return;

    const cartItem = removeButton.closest('.cart-item');
    if (!cartItem) return;
    
    const productType = cartItem.dataset.productType;
    
    if (productType === 'Jersey') {
      event.preventDefault();
      
      const personalizationItem = Array.from(document.querySelectorAll('.cart-item'))
        .find(item => item.dataset.productType === 'Personalización');
        
      if (personalizationItem) {
        const originalHref = removeButton.getAttribute('href');
        window.location.href = originalHref;
        
        setTimeout(() => {
          const personalizationRemoveLink = personalizationItem.querySelector('cart-remove-button a');
          if (personalizationRemoveLink) {
            window.location.href = personalizationRemoveLink.getAttribute('href');
          }
        }, 500);
      }
    } else if (productType === 'Personalización') {
      event.preventDefault();
      const originalHref = removeButton.getAttribute('href');
      window.location.href = originalHref;
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  });
});